import { useState } from "react";
import { DialogTrigger } from "react-aria-components";

import { PickerDialog } from "./assets/PickerDialog";
import { DefaultTrigger } from "./triggers/DefaultTrigger";
import { PickerItem, PickerProps } from "./types";
import { _ResponsivePopover } from "../_assets/_ResponsivePopover";

export type { PickerProps };

export function Picker<T extends PickerItem>(props: PickerProps<T>) {
  const {
    label,
    testID = "picker",
    trigger = DefaultTrigger,
    placement = "bottom left",
    minWidth = "280px",
    maxWidth = "280px",
    triggerRef,
    matchTriggerMaxWidth = false,
    onOpenChange,
  } = props;

  const [isOpen, setOpen] = useState(false);

  const items = props.items ? Array.from(props.items) : [];

  const selectedItems = items.filter((item) => {
    return (
      props.selectedKeys && Array.from(props.selectedKeys).includes(item.id)
    );
  });

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={(value) => {
        setOpen(value);
        onOpenChange?.(value);
      }}
    >
      {trigger({
        label,
        isOpen,
        onToggle: () => setOpen((curr) => !curr),
        count: Array.isArray(props.selectedKeys)
          ? props.selectedKeys.length
          : selectedItems.length,
        selectedItems,
        selectionMode: props.selectionMode,
        icon: props.icon,
        testID: `${testID}-trigger`,
        isDisabled: props.isDisabled,
      })}
      <_ResponsivePopover
        isDismissable
        isOpen={isOpen}
        onOpenChange={setOpen}
        popoverPlacement={placement}
        popoverMinWidth={triggerRef?.current?.clientWidth || minWidth}
        popoverMaxWidth={
          matchTriggerMaxWidth && triggerRef?.current?.clientWidth
            ? `${triggerRef.current.clientWidth}px`
            : maxWidth
        }
      >
        <PickerDialog
          {...props}
          onClose={() => setOpen(false)}
          truncateItem={props.truncateItem}
        />
      </_ResponsivePopover>
    </DialogTrigger>
  );
}
